/* recovered from production bundle — lib/config */
// @ts-nocheck

export const appConfig = {
  defaultLoginEmail: import.meta.env.VITE_DEFAULT_LOGIN_EMAIL ?? 'admin@local',
  appTitle: import.meta.env.VITE_APP_TITLE ?? 'DB Tool Box',
  appSubtitle: import.meta.env.VITE_APP_SUBTITLE ?? 'Database Administration',
  appVersion: import.meta.env.VITE_APP_VERSION ?? '1.0.0',
  stack: import.meta.env.VITE_APP_STACK ?? 'unknown',
  edition: import.meta.env.VITE_EDITION ?? 'full',
};

export const isLiteEdition = appConfig.edition === 'lite';
